<template>
  <bvue-ui-view class="flex flex-col">
    <div class="flex items-center">
      <h1>Seriales</h1>
      <div class="flex-1 flex justify-end">
        <button @click="add" class="btn btn-primary">Añadir</button>
      </div>
    </div>  
    <p>Pulsa en la fila para editar</p>
    <div class="flex-1 overflow-scroll relative">
      <sortable-table :items="items" :columns="columns" startSort="id" @rowSelected="rowSelected"/>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import SortableTable from '@/components/SortableTable'
import SerialesDetails from '@/pages/admin/SerialesDetails'
export default {
  name: 'Seriales',
  data() {
    return {
      columns: [
        {
          key: 'id',
          name: 'serial',
          align: 'left',
          sortable: true,
          type: 'text'
        },{
          key: 'user',
          name: 'donante',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'status',
          name: 'estado',
          align: 'left',
          sortable: true,
          type: 'text'
        }
      ],
      sort: 'id',
      order: 'asc'
    }
  },
  components: {
    SortableTable
  },
  computed: {
    items() {
      var response = []
      const itemsObj = this.$store.state.seriales.items
      for (const key in itemsObj) {
          response.push(itemsObj[key])
      }
      return response
    }
  },
  methods: {
    add() {
      this.showDetails()
    },
    rowSelected(args) {
      if (args.length > 1) {
        const item = args[1]
        this.showDetails(item)
      }
    },
    showDetails(item) {
      this.$bvueUi.modal.show({
        component: SerialesDetails,
        width: 800,
        height: 800,
        data: item
      })
    }
  },
  created() {
    this.$store.dispatch('seriales/initialize')
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/Seriales.vue